/**
 * @deprecated Import from "@/modules/loan/store" instead.
 * This file is a re-export stub kept for backward compatibility with external consumers.
 */
export { loanService } from "@/modules/loan/store/services/loan-service";

export {
  useGetLoansQuery,
  useGetLoansKanbanQuery,
  useGetLoanQuery,
  useGetLoanLendersHeatMapQuery,
  useAddLoanMutation,
  usePatchLoanMutation,
  useDeleteLoanMutation,
} from "@/modules/loan/store/services/endpoints";
